import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

/** Duas confirmações visuais antes de executar uma exclusão administrativa. */
export default function AdminDeleteConfirmation({ itemName, onConfirm, disabled = false, children }) {
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  const close = () => { if (!busy) { setOpen(false); setStep(1); setTyped(""); } };
  const confirm = async () => {
    if (typed !== "EXCLUIR" || busy) return;
    setBusy(true);
    try { await onConfirm(); close(); } finally { setBusy(false); }
  };
  return <>
    <span onClick={() => !disabled && setOpen(true)}>{children}</span>
    <Dialog open={open} onOpenChange={(value) => value ? setOpen(true) : close()}>
      <DialogContent className="border-red-500/30 bg-[#071A33] text-white">
        <DialogHeader><DialogTitle>{step === 1 ? "Deseja realmente excluir este registro?" : "Confirmação definitiva"}</DialogTitle></DialogHeader>
        {step === 1 ? <>
          <p className="text-sm text-slate-300">Você está prestes a excluir <strong className="text-white">{itemName}</strong>. Essa ação poderá remover permanentemente suas informações.</p>
          <div className="mt-5 flex justify-end gap-3"><Button variant="outline" onClick={close}>Cancelar</Button><Button variant="destructive" onClick={() => setStep(2)}>Continuar exclusão</Button></div>
        </> : <>
          <p className="text-sm text-red-200">Essa ação não poderá ser desfeita. Digite <strong>EXCLUIR</strong> para confirmar.</p>
          <Input autoFocus value={typed} onChange={e => setTyped(e.target.value)} placeholder="EXCLUIR" className="mt-4 border-red-500/30 bg-[#0D2A52] text-white" />
          <div className="mt-5 flex justify-end gap-3"><Button variant="outline" onClick={close} disabled={busy}>Cancelar</Button><Button variant="destructive" onClick={confirm} disabled={typed !== "EXCLUIR" || busy}>{busy ? "Excluindo…" : "Excluir definitivamente"}</Button></div>
        </>}
      </DialogContent>
    </Dialog>
  </>;
}
